<template>
    <div id="app">
        <div v-if="this.brand === 'raigmore'" class="alert alert-default row alert-dismissible fade show raigmore-alert" role="alert">
            <div class="container">
                <strong>Need support or having problems?<a :href="support" target="_blank"> Get help</a></strong>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                   &times;
                </button>
            </div>
        </div>
        <Header></Header>
        <main>
            <router-view></router-view>
            <br>
            <br>
            <div class="grey-background-section mt-5">
                <GetHelpBanner></GetHelpBanner>
            </div>
            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <MainFooter></MainFooter>
                        </div>
                        <div v-if="this.brand === 'nhs'" class="col-12 col-lg-6">
                            <supported></supported>
                        </div>
                    </div>
                </div>
            </footer>
        </main>
        <footer class="cookie">
            <cookie-law buttonText="Accept Cookies">
                <div slot="message" >
                    This website uses cookies to ensure you get the best experience, for more information  <router-link :to="{ name: 'Cookies' }" >Click Here</router-link>
                </div>
            </cookie-law>
            <CampaignModal v-if="activeCampaign && canAppear($route.name)" :active-campaign="activeCampaign"/>
        </footer>
    </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import CampaignModal from '@/components/CampaignModal.vue'
import Header from 'header/Header.vue';
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import Supported from './components/SupportedByFooter.vue'
import MainFooter from './components/MainFooter.vue'
import GetHelpBanner from './components/GetHelpBanner.vue'

const whitelabel = require('../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            icon: whitelabel.icon,
            name: whitelabel.title,
            brand: whitelabel.brand,
            support: whitelabel.support,
        }
    },
    components: {
        CookieLaw,
        Header,
        Supported,
        MainFooter,
        GetHelpBanner,
        CampaignModal,
    },
    created() {
        const icon = document.getElementById('icon-base')
        icon.href = this.icon
        document.title = this.name
        this.fetchActiveCampaign()
    },
    methods: {
        ...mapActions([
            'getActiveCampaign',
        ]),
        fetchActiveCampaign() {
            this.clearOlderThanADay()
            this.getActiveCampaign({
                params: {
                    order_by: 'end_at',
                    order: 'asc',
                    per_page: 1,
                    impression_ids: this.campaignImpressionIds,
                },
            })
        },
        canAppear(currentRouteName) {
            if (this.activeCampaign.appear_on === 'journey-planner' && currentRouteName === 'Home') {
                return true
            } if (this.activeCampaign.appear_on === 'journey-results' && currentRouteName === 'Results') {
                return true
            } if (this.activeCampaign.appear_on === 'journey-details' && currentRouteName === 'Journey') {
                return true
            } if (this.activeCampaign.appear_on === 'account-register' && (currentRouteName === 'Register' || currentRouteName === 'Account')) {
                return true
            }
            return false
        },
        clearOlderThanADay() {
            const dateToday = moment()
            const impressionsArray = this.campaignImpressions
            for (let i = 0; i < impressionsArray.length; i += 1) {
                if (moment(impressionsArray[i].expires_at).add(1, 'days').isBefore(dateToday)) {
                    this.campaignImpressions.splice(i, 1)
                }
            }
        },
    },
    computed: {
        ...mapState([
            'activeCampaign',
            'campaignImpressions',
        ]),
        ...mapGetters([
            'campaignImpressionIds',
        ]),
    },
};

</script>

<style lang="scss">
#app {
    font-family: 'PT Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
main{
  padding-bottom: 100px;
}
@media screen and (max-width: 425px) {
main{
  padding-bottom: 200px;
}
}
.cookie{
  margin-top: -50px;
}
</style>
